var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.SVGIconClass,style:(_vm.SVGIconStyle),on:{"mouseenter":function($event){return _vm.mouseEnter()},"mouseleave":function($event){return _vm.mouseLeave()}}})}
var staticRenderFns = []

export { render, staticRenderFns }